<script setup lang="ts">
  import { ref, onMounted, onBeforeUnmount, defineAsyncComponent } from 'vue';
  import WModal from 'src/components/base/Modal.vue';
  import MapSkeleton from 'src/assets/images/map_skeleton.png';
  import { themeIcons } from 'src/utils/config';
  const WidgetIcon = defineAsyncComponent(() => import('src/components/base/WidgetIcon.vue'));

  interface Props {
    isDataInitialized: boolean;
  }

  defineProps<Props>();
  const headerRef = ref<HTMLElement | null>(null);
  const mapHeight = ref('100%');

  const observer = new ResizeObserver(() => {
    const offset = 119;
    const headerHeight = headerRef.value?.clientHeight || 0;
    mapHeight.value = `calc(100vh - ${headerHeight + offset}px)`;
  });

  onMounted(() => {
    const offset = 119;
    const headerHeight = headerRef.value?.clientHeight || 0;
    mapHeight.value = `calc(100vh - ${headerHeight + offset}px)`;
    if (headerRef.value) {
      observer.observe(headerRef.value);
    }
  });

  onBeforeUnmount(() => {
    if (headerRef.value) {
      observer.unobserve(headerRef.value);
    }
  });
  const isOpen = ref(true);
</script>

<template>
  <WModal
    v-model="isOpen"
    size="full"
    body-class="!max-h-dvh !h-dvh !my-0 justify-center items-center flex !p-0 w-full"
  >
    <div class="flex h-full w-full flex-col bg-white md:flex-row">
      <div class="h-[50%] w-full p-4 md:h-full md:w-[40%] md:min-w-[300px] md:max-w-[550px]">
        <slot name="sideBar"></slot>
      </div>

      <div class="relative flex-1">
        <div class="relative h-[50%] md:h-full">
          <slot name="map"></slot>

          <div
            v-if="!isDataInitialized"
            class="relative flex h-[50vh] w-full items-center justify-center md:h-full md:h-screen"
          >
            <img
              :src="MapSkeleton"
              class="map-skeleton-bg absolute top-0 z-0 h-full w-full animate-pulse object-cover"
            />
            <WidgetIcon :icon="themeIcons.marker" class="widget-primary-icon z-10 size-12 animate-pulse" />
          </div>
        </div>
      </div>
    </div>
  </WModal>
</template>
